<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un día</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los días</option>
        <option v-for="AgendaBloqueFecha in AgendaBloqueFechas" :value="AgendaBloqueFecha.FechaBloque" :key="AgendaBloqueFecha.FechaBloque">{{AgendaBloqueFecha.FechaHoraString.substring(0, 10)}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        AgendaBloqueFechas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch("A_SICCIJ_Catalogo_Establecer001Area", parametros);
    },
    methods: {
      cargaCatalogoAgendaBloqueFechas() {
        console.log('cargando')
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SICCIJ.catalogos.C004AgendaBloquesFechas, this.parametros, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal))
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.AgendaBloqueFechas = respuesta.data.AgendaBloqueFechas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                //this.AgendaBloqueFechas = respuesta.data.AgendaBloqueFechas.filter(cond => this.parametros.filtros.some(area => area == cond.AreaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        console.log(evento.target.value)
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer004AgendaBloquesFechas", parametros);
        this.$emit("valorParaElPadre", [evento,this.AgendaBloqueFechas[evento.target.selectedIndex -1]]);
        
      }
    },
    created() {
      this.cargaCatalogoAgendaBloqueFechas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/C004AgendaBloquesFechas.vue